import { InstallmentsTimesEnum, PaymentType } from 'constants/reservations';
import { paymentTypeLabels, InstallmentLabels } from 'constants/reservations';
import type { CardInstallments } from 'ReservationsList-Types';

export const getPaymentMethodDisplayText = (
  paymentMethod: PaymentType,
  cardInstallments?: CardInstallments,
) => {
  return paymentMethod === PaymentType.CREDIT_CARD
    ? InstallmentLabels[cardInstallments || InstallmentsTimesEnum.INSTALLMENTS_1]
    : paymentTypeLabels[paymentMethod];
};
